// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// کامپوننت‌های محافظ
import ProtectedRoute from "./components/ProtectedRoute";

// صفحات
import MainPage from "./pages/MainPage";
import Login from "./components/Login";
import Admin from "./pages/Admin";
import RegisterPage from "./pages/RegisterPage";
import PendingApprovalPage from "./pages/PendingApprovalPage";
import LoginPage from "./pages/LoginPage";
import UserPortalGuard from "./components/UserPortalGuard";
import BalancePage from "./pages/BalancePage";
import TransferPage from "./pages/TransferPage";
import TransactionsPage from "./pages/TransactionsPage";
import PriceChangesPage from "./pages/PriceChangesPage";
import SettingsPage from "./pages/SettingsPage";
import GalleryDetailPage from "./pages/GalleryDetailPage";

function App() {
  const publicUrl = process.env.PUBLIC_URL || "/";
  const routerBasename = (() => {
    try {
      return new URL(publicUrl).pathname.replace(/\/+$/, "") || "/";
    } catch {
      return publicUrl.replace(/\/+$/, "") || "/";
    }
  })();
  
  // ─────────────────────────────────────────────
  // تشخیص ورود کاربر و لاگ کردن اطلاعات
  // ─────────────────────────────────────────────
  useEffect(() => {
    const token = localStorage.getItem("token");
    const userData = localStorage.getItem("user");
    
    if (token && userData) {
      try {
        const user = JSON.parse(userData);
        console.log("═══════════════════════════════════════");
        console.log("✅ کاربر وارد شد!");
        console.log("👤 آیدی کاربر:", user.id);
        console.log("🔐 نام کاربری:", user.identifier);
        console.log("🔑 رمز عبور:", user.password);
        console.log("📛 نام:", user.firstName, user.lastName);
        console.log("📞 شماره تماس:", user.phone);
        console.log("═══════════════════════════════════════");
      } catch (error) {
        console.error("خطا در خواندن اطلاعات کاربر:", error);
      }
    }
  }, []);

  return (
    <>
      <Router basename={routerBasename}>
        
        <Routes>
          {/* صفحات عمومی - فقط برای مهمانان */}
          <Route
            path="login"
            element={
                <Login />
            }
          />
          <Route
            path="/register"
            element={
                <RegisterPage />
            }
          />
          <Route
            path="/loginpage"
            element={
                <LoginPage />
            }
          />
          <Route
            path="/pending"
            element= {
                <PendingApprovalPage />
            }
          />
          {/* صفحات عمومی - بدون محدودیت */}
          <Route path="/" element={<MainPage />} />
          <Route path="/gallery/:id" element={<GalleryDetailPage />} />
          {/* صفحات محافظت‌شده - فقط برای کاربران واردشده */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/balance"
            element={
              <UserPortalGuard>
                <BalancePage />
              </UserPortalGuard>
            }
          />
          <Route
            path="/transfer"
            element={
              <UserPortalGuard>
                <TransferPage />
              </UserPortalGuard>
            }
          />
          <Route
            path="/transactions"
            element={
              <UserPortalGuard>
                <TransactionsPage />
              </UserPortalGuard>
            }
          />
          <Route
            path="/price-changes"
            element={
              <UserPortalGuard>
                <PriceChangesPage />
              </UserPortalGuard>
            }
          />
          <Route
            path="/settings"
            element={
              <SettingsPage />
            }
          />
          {/* مسیر پیش‌فرض */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
      <ToastContainer position="top-center" autoClose={3000} />
    </>
  );
}

export default App;
